export function removeUtms() {
  if (window.location.search.indexOf('utm_') != -1 && history.replaceState) {
    history.replaceState(
      {},
      '',
      window.location.toString().replace(/(\&|\?)utm([_a-z0-9=]+)/g, '')
    );
  }
}
